import { ActionStatus } from '../../../api/vault/assetStatus/interfaces';
import { StreamStatus } from '../../../enums';

export const statusToText: { [key: string]: string } = {
  [ActionStatus.Queued]: 'Queued',
  [ActionStatus.InProgress]: 'In Progress',
  [ActionStatus.Transcoding]: 'Transcoding',
  [ActionStatus.Completed]: 'Completed',
  [ActionStatus.Failed]: 'Failed',
};
